// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep .erpDrawer .el-drawer__header{height:50px;line-height:50px;padding-left:24px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
